import { cva, type VariantProps } from 'class-variance-authority';
import { LoaderCircle } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

const loaderVariants = cva('animate-spin text-muted-foreground', {
  variants: {
    size: {
      default: 'size-6',
      sm: 'size-4',
      lg: 'size-8',
      xl: 'size-10',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

interface LoaderProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof loaderVariants> {
  className?: string;
}

function Loader({ className, size, ...props }: LoaderProps) {
  return (
    <div className="flex items-center justify-center" {...props}>
      <LoaderCircle className={cn(loaderVariants({ size, className }))} />
    </div>
  );
}

export { Loader, loaderVariants };
